import { useEffect, useState } from "react";

// ui
import {
  Box,
  IconButton,
  Alert,
  Chip,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// Table
import TableTopBar from "../component/TableTopBar";
import { ConstTable } from "../component/Table";
import { EmptyState } from "../component/EmptyState";
import { DataDetailTable } from "../component/detail/DataDetailTable";
import { PostCSVModal } from "../component/PostCSVModal";
import { PostCSVContractStatusModal } from "../component/PostCSVContractStatusModal";

// Bar
import { SerchSideBar } from "../component/SerchSideBar";

// Modal
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { ContractAddModal } from "../component/ContractAddModal";
import { GetXLSXContractModal } from "../component/GetXLSXContractModal";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";
import { DataCancelModal } from "../component/tableFunction/DataCancelModal";
import { ContractCopyTossUpModal } from "../component/tableFunction/ContractCopyTossUpModal";
import { ContractCopyEntryModal } from "../component/tableFunction/ContractCopyEntryModal";
import { PersonDataDeleteModal } from "../component/tableFunction/PersonDataDeleteModal";
import { ChangeAccountCollaborateModal } from "../component/tableFunction/ChangeAccountCollaborateModal";
import { ColumnSettingModal } from "../component/ColumnSettingModal";

// jotai
import { useSetAtom, useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getContracts,
  getContract,
  putContract,
  postContract,
  deleteContract,
  cancellContract,
  getCancellSmsOptions,
  getContractProducts,
  getContractCopyTossUpAddBefore,
  getContractCopyEntryBefore,
  postContractShortMessage,
  deletePersonContract,
} from "../api/contract";
import { postTossUp } from "../api/tossUp";
import { getContractServiceContents } from "../api/contractServiceContent";
import {
  getContractCustomerInfos,
  putContractCustomerInfo,
} from "../api/contractCustomerInfo";
import {
  getContractContractInfos,
  deleteContractContractInfo,
} from "../api/contractContractInfo";
import { getOldContract } from "../api/oldContract";
import {
  getSerchCategorys,
  getSerchHighRankCompanys,
  getSerchProducts,
  getSerchAccountSales,
  getSerchSaleCompanys,
  getSerchSaleCompanyGroups,
  getSerchAccountCollaborateCompanys,
  getProductCandidatesEntry,
} from "../api/serch";
import {
  getPresignedPostCSV,
  postPresignedPost,
  getPresignedPostPicture,
  getPostCSVHeader,
} from "../api/presignedURL";
import {
  getScreenColumns,
  getScreenColumnContracts,
  putScreenColumnContracts,
} from "../api/screenColumn";

// InterFace
import { contractTableColumn } from "../config/contract";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";
import {
  isTableFunctionDisabled,
  detailToFacts,
} from "../component/tableFunctionRules";

// 営業アカウント更新取込
const putCSVColumnSaleAccount: { name: string; required: boolean }[] = [
  { name: "商材名", required: true },
  { name: "プラン名", required: true },
  { name: "顧客電話番号", required: true },
  { name: "申込番号", required: true },
  { name: "変更後パートナー", required: true },
  { name: "変更後営業アカウント", required: true },
];

// 申込番号取込
const putCSVColumnContractNumber: { name: string; required: boolean }[] = [
  { name: "商材名", required: true },
  { name: "プラン名", required: true },
  { name: "顧客電話番号", required: true },
  { name: "申込番号", required: true },
];

// 契約事前一括取込
const postCSVColumnAdminContract: { name: string; required: boolean }[] = [
  { name: "パートナー", required: true },
  { name: "営業アカウント氏名", required: true },
  { name: "上位店名", required: true },
  { name: "商材名", required: true },
  { name: "支払方法", required: false },
  { name: "リストID", required: false },
  { name: "プラン名", required: true },
  { name: "コンテンツ1", required: false },
  { name: "コンテンツ2", required: false },
  { name: "コンテンツ3", required: false },
  { name: "コンテンツ4", required: false },
  { name: "コンテンツ5", required: false },
  { name: "コンテンツ6", required: false },
  { name: "コンテンツ7", required: false },
  { name: "コンテンツ8", required: false },
  { name: "コンテンツ9", required: false },
  { name: "コンテンツ10", required: false },
  { name: "コンテンツ11", required: false },
  { name: "コンテンツ12", required: false },
  { name: "コンテンツ13", required: false },
  { name: "コンテンツ14", required: false },
  { name: "コンテンツ15", required: false },
  { name: "コンテンツ16", required: false },
  { name: "コンテンツ17", required: false },
  { name: "コンテンツ18", required: false },
  { name: "コンテンツ19", required: false },
  { name: "コンテンツ20", required: false },
  { name: "キャンペーン1", required: false },
  { name: "キャンペーン2", required: false },
  { name: "キャンペーン3", required: false },
  { name: "キャンペーン4", required: false },
  { name: "キャンペーン5", required: false },
  { name: "キャンペーン6", required: false },
  { name: "キャンペーン7", required: false },
  { name: "キャンペーン8", required: false },
  { name: "キャンペーン9", required: false },
  { name: "キャンペーン10", required: false },
  { name: "顧客電話番号", required: true },
  { name: "顧客氏名", required: true },
  { name: "顧客会社名", required: true },
  { name: "申込番号", required: false },
  { name: "申込日", required: false },
  { name: "開通日", required: false },
  { name: "解約日", required: false },
  { name: "ステータス", required: false },
];
const postCSVColumnAdminContractResult = [
  "パートナー",
  "営業アカウント氏名",
  "上位店名",
  "商材名",
  "支払方法",
  "リストID",
  "プラン名",
  "顧客電話番号",
  "顧客氏名",
  "顧客会社名",
  "申込番号",
];

// 契約一括エントリー
const postCSVColumnEntryContract: { name: string; required: boolean }[] = [
  { name: "営業アカウント氏名", required: true },
  { name: "商材名", required: true },
  { name: "支払方法", required: false },
  { name: "リストID", required: false },
  { name: "プラン名", required: true },
  { name: "コンテンツ1", required: false },
  { name: "コンテンツ2", required: false },
  { name: "コンテンツ3", required: false },
  { name: "コンテンツ4", required: false },
  { name: "コンテンツ5", required: false },
  { name: "コンテンツ6", required: false },
  { name: "コンテンツ7", required: false },
  { name: "コンテンツ8", required: false },
  { name: "コンテンツ9", required: false },
  { name: "コンテンツ10", required: false },
  { name: "コンテンツ11", required: false },
  { name: "コンテンツ12", required: false },
  { name: "コンテンツ13", required: false },
  { name: "コンテンツ14", required: false },
  { name: "コンテンツ15", required: false },
  { name: "コンテンツ16", required: false },
  { name: "コンテンツ17", required: false },
  { name: "コンテンツ18", required: false },
  { name: "コンテンツ19", required: false },
  { name: "コンテンツ20", required: false },
  { name: "キャンペーン1", required: false },
  { name: "キャンペーン2", required: false },
  { name: "キャンペーン3", required: false },
  { name: "キャンペーン4", required: false },
  { name: "キャンペーン5", required: false },
  { name: "キャンペーン6", required: false },
  { name: "キャンペーン7", required: false },
  { name: "キャンペーン8", required: false },
  { name: "キャンペーン9", required: false },
  { name: "キャンペーン10", required: false },
  { name: "エントリーパートナー", required: false },
];
// spec 外の chip 表示専用
const postCSVColumnEntryContractExtraChips = ["商材による質問"];

const postCSVColumnEntryContractResult = [
  "営業アカウント氏名",
  "商材名",
  "支払方法",
  "リストID",
  "プラン名",
];

// 契約サービス一括変更
const putCSVColumnContractService: { name: string; required: boolean }[] = [
  { name: "上位店名", required: true },
  { name: "商材名", required: true },
  { name: "申込番号", required: true },
  { name: "顧客電話番号", required: true },
  { name: "プラン名", required: true },
  { name: "コンテンツ1", required: true },
  { name: "コンテンツ2", required: true },
  { name: "コンテンツ3", required: true },
  { name: "コンテンツ4", required: true },
  { name: "コンテンツ5", required: true },
  { name: "コンテンツ6", required: true },
  { name: "コンテンツ7", required: true },
  { name: "コンテンツ8", required: true },
  { name: "コンテンツ9", required: true },
  { name: "コンテンツ10", required: true },
  { name: "コンテンツ11", required: true },
  { name: "コンテンツ12", required: true },
  { name: "コンテンツ13", required: true },
  { name: "コンテンツ14", required: true },
  { name: "コンテンツ15", required: true },
  { name: "コンテンツ16", required: true },
  { name: "コンテンツ17", required: true },
  { name: "コンテンツ18", required: true },
  { name: "コンテンツ19", required: true },
  { name: "コンテンツ20", required: true },
  { name: "キャンペーン1", required: true },
  { name: "キャンペーン2", required: true },
  { name: "キャンペーン3", required: true },
  { name: "キャンペーン4", required: true },
  { name: "キャンペーン5", required: true },
  { name: "キャンペーン6", required: true },
  { name: "キャンペーン7", required: true },
  { name: "キャンペーン8", required: true },
  { name: "キャンペーン9", required: true },
  { name: "キャンペーン10", required: true },
];
const putCSVColumnContractServiceResult = [
  "上位店名",
  "商材名",
  "申込番号",
  "顧客電話番号",
  "プラン名",
];

function Contract() {
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const contractScreenColumn = useAtomValue(AppAtoms.contractScreenColumn);
  const setContractScreenColumn = useSetAtom(AppAtoms.contractScreenColumn);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const setDetailBreadcrumb = useSetAtom(AppAtoms.detailBreadcrumb);

  // アンマウント時にパンくずクリア
  useEffect(() => {
    return () => {
      setDetailBreadcrumb(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    { auth: ["パートナー", "営業アカウント"], name: "エントリー" },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "運用前契約情報一括CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "申込番号CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "契約状況CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "契約サービスCSV更新取込",
    },
    {
      auth: ["パートナー", "営業アカウント"],
      name: "CSV一括エントリー",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      name: "営業アカウント更新CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      name: "エントリー一覧出力",
    },
  ];
  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "エントリー") {
      setAddData({
        ...addData,
        addStatus: "change_account",
      });
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "契約状況CSV取込") {
      setPostCSVStatus({
        ...postCSVStatus,
        status: "open",
      });
    }
    if (addCSVDataName === "契約サービスCSV更新取込") {
      setPutCSVContractService({
        ...putCSVContractService,
        status: "open",
      });
    }
    if (addCSVDataName === "営業アカウント更新CSV取込") {
      setPostCSVSaleAccount({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "申込番号CSV取込") {
      setPostCSVContractNumber({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "運用前契約情報一括CSV取込") {
      setPostContractCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "CSV一括エントリー") {
      setPostCSVEntryContract({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  useEffect(() => {
    if (getXLSXDataName === "エントリー一覧出力") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "open",
      });
    }
  }, [getXLSXDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "コンテンツ一覧") {
      getSubtableDataContractServiceContent();
    }
    if (getSubTableName.name === "顧客情報一覧") {
      getSubtableDataContractCustomerInfo();
    }
    if (getSubTableName.name === "契約情報一覧") {
      getSubtableDataContractContractInfo();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
    subTableColumnName?: string;
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "トスアップ複製") {
      setEntryToTossUpDataInf({
        ...entryToTossUpDataInf,
        addStatus: "change_account",
      });
    }
    if (tableOriginalFunc.name === "エントリー複製") {
      setEntryToEntryDataInf({
        ...entryToEntryDataInf,
        addStatus: "change_account",
        contractId: tableOriginalFunc.key.id as string,
      });
    }
    if (tableOriginalFunc.name === "エントリー取消") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "解約") {
      const key = tableOriginalFunc.key;
      setCancelDataInf({
        status: "loading",
        key,
        message: "",
        cancellAction: key.cancell_action ?? "",
        cancellSmsList: [],
        selectedCancellSms: null,
        destinationPhoneNumber: "",
        destinationMailAddress: "",
      });
      (async () => {
        const res = await getCancellSmsOptions(key.id);
        setCancelDataInf((prev) =>
          prev.key.id === key.id
            ? {
                ...prev,
                status: "open",
                cancellSmsList: res.cancell_sms_list,
                destinationPhoneNumber: res.destination_phone_number,
                destinationMailAddress: res.destination_mail_address,
              }
            : prev,
        );
      })();
    }
    if (tableOriginalFunc.name === "個人情報削除") {
      setDeletePersonDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "契約情報一覧"
    ) {
      setDeleteContractInfoDataInf({
        status: "open",
        key: { infoKey: tableOriginalFunc.key.contract_info_key },
        message: "",
      });
    }
  }, [
    tableOriginalFunc.name,
    tableOriginalFunc.key,
    tableOriginalFunc.subTableColumnName,
  ]);

  const [serchOpen, setSerchOpen] = useState(false);
  const aiChatOpen = useAtomValue(AppAtoms.aiChatOpen);
  const setAiChatOpenAtom = useSetAtom(AppAtoms.aiChatOpen);

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);
  const firstYear = getFirstYear();
  const { thisYear } = getOneYear();
  const [firstLoading, setFirstLoading] = useState(true);

  // カラムデータの設定
  const [columnSetting, setColumnSetting] = useState<{
    status: "none" | "open" | "loading" | "result" | "error";
    columns: {
      id: number;
      screen_column_auth: 0 | 1;
      screen_column_system_default: 0 | 1;
      table_disabled: 0 | 1;
      screen_column_serch_disabled: 0 | 1;
      detail_disabled: 0 | 1;
      screen_column_name: string;
      screen_column_type: 0 | 1 | 2;
      table_sort: 0 | 1;
      screen_column_table: 0 | 1;
      table_column_size: string;
      screen_column_sort_id: number;
      screen_column_serch: 0 | 1;
      screen_column_detail: 0 | 1;
    }[];
  }>({
    status: "none",
    columns: [],
  });
  useEffect(() => {
    if (columnSetting.status === "loading") {
      setIsLoading(true);
    } else if (columnSetting.status !== "none") {
      setIsLoading(false);
    }
  }, [columnSetting]);

  async function openColumnSettingWindow() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    // 既存カラムの取得
    const { fetch_data } = await getScreenColumnContracts();
    setColumnSetting({
      status: "open",
      columns: fetch_data,
    });
  }

  async function putClumnSetting() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    const res = await putScreenColumnContracts(columnSetting.columns);
    if (res === "success") {
      setChangeTableData(false);
      setColumnLoading(true);
      await getTableData(true);
      const { contractScreenColumn } = await getScreenColumns();
      setContractScreenColumn(contractScreenColumn);
      setColumnSetting({
        ...columnSetting,
        status: "result",
      });
    } else {
      setColumnSetting({
        ...columnSetting,
        status: "error",
      });
    }
  }

  function closeColumnSettingModal() {
    setColumnSetting({
      status: "none",
      columns: [],
    });
  }

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | string[] };
  } | null>(null);

  const [dataDetailOption, setDataDetailOption] = useState<
    { [key: string]: string | number }[]
  >([]);

  const [dataDetailHistory, setDataDetailHistory] = useState<
    { selected_date: string; contract_version: number }[]
  >([]);
  const [selectHistory, setSelectHistory] = useState<number>(0);
  const [lastContractVersion, setLastContractVersion] = useState<number>(0);
  useEffect(() => {
    if (dataDetailHistory.length === 0) {
      setLastContractVersion(0);
      return;
    }
    const last = dataDetailHistory.reduce(
      (max, item) =>
        item.contract_version > max ? item.contract_version : max,
      dataDetailHistory[0].contract_version,
    );
    setLastContractVersion(last);
  }, [dataDetailHistory]);

  // 詳細ページ表示フラグ
  const [detailView, setDetailView] = useState<boolean>(false);

  // 詳細ビューを閉じる
  function closeDetailView() {
    setDetailView(false);
    setDataDetail(null);
    setDetailBreadcrumb(null);
  }

  // 契約情報一覧（詳細ページ内表示用）
  const [detailContractInfos, setDetailContractInfos] = useState<
    { contract_info_key: string; contract_info_value: string }[]
  >([]);
  useEffect(() => {
    if (detailView && dataDetail?.id) {
      getContractContractInfos(dataDetail.id as string)
        .then((fetchData) => {
          const contractInfo = fetchData.sudDatas[0].contract_info as {
            [key: string]: string;
          };
          setDetailContractInfos(
            Object.keys(contractInfo).map((key) => ({
              contract_info_key: key,
              contract_info_value: contractInfo[key],
            })),
          );
        })
        .catch(() => setDetailContractInfos([]));
    } else {
      setDetailContractInfos([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailView, dataDetail]);

  // データ編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  const [selectServiseInfo, setSelectServiseInfo] = useState<{
    service_plan_data: { service_name: string }[];
    service_content_data: { service_name: string }[];
    service_campaign_pulldown_data: { service_name: string }[];
    service_campaign_checkbox_data: { service_name: string }[];
  }>({
    service_plan_data: [],
    service_content_data: [],
    service_campaign_pulldown_data: [],
    service_campaign_checkbox_data: [],
  });
  const [addData, setAddData] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    outSiteEntry: 0,
    outsideSiteUrl: "",
    outsideServiceUrl: "",
    viewOutsideServiceUrl: 0,
    productId: null,
    productName: "",
    phone_number: "",
    have_entry_form: null,
    site_path_list: [],
    site_path: "",
    outsideMessageType: null,
    customer_name: "",
    customer_company_name: "",
    servicePlanName: "",
    serviceContentNameList: [],
    serviceCampaignPulldownName: "",
    serviceCampaignCheckboxName: [],
    servicePaymentMethodName: "",
    serviseCustomerListID: "",
    pullDownServiceName: "",
    checkBoxServiceNames: "",
    smsMessagePatternID: null,
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  // addStatus が loadingのとき
  useEffect(() => {
    if (addData.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [addData]);

  // 商材一覧取得
  const [contractProductList, setContractProductList] = useState<
    {
      id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[]
  >([]);

  async function getContractProductList() {
    setAddData({
      ...addData,
      addStatus: "loading",
    });
    const contractProductList = await getContractProducts(
      addData.changeAccount,
      addData.changeAccountID,
    );
    if (contractProductList) {
      setContractProductList(contractProductList);
      // 製品選択画面に移行
      setAddData({
        ...addData,
        addStatus: "product",
      });
    } else {
      closeAddModal();
      setOnDataAddModalResult(
        "エントリー可能な商材が定義されていません。管理者に問い合わせてください。",
      );
    }
  }
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");

  // データのトスアップへのコピー
  const [entryToTossUpDataInf, setEntryToTossUpDataInf] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    contract_id: string;
    toss_up_id: string;
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    contract_id: "",
    toss_up_id: "",
    category_id_list: [],
    product_name_list: [],
    phone_number: "",
    customer_name: "",
    customer_list_id: "",
    hope_call_date: "",
    hope_call_time_kind: null,
    hope_call_time: "12-00",
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  useEffect(() => {
    if (entryToTossUpDataInf.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [entryToTossUpDataInf]);
  const [tossUpCategoryNameList, setTossUpCategoryNameList] = useState<
    {
      category_id: number;
      category_name: string;
    }[]
  >([]);
  const [tossUpProductNameList, setTossUpProductNameList] = useState<
    {
      category_id: number;
      category_name: string;
      product_name: string;
    }[]
  >([]);
  // 画像データ保持用
  const [entryToTossUpPostPictures, setEntryToTossUpPostPicture] = useState<{
    [key: string]: File;
  }>({});
  const [entryToTossUpUniqueOptinList, setEntryToTossUpUniqueOptinList] =
    useState<{ [key: string]: string | number | string[] }[]>([]);
  const [entryToTossUpAddressOptionName, setEntryToTossUpAddressOptionName] =
    useState("");
  async function openEntryToTossUp() {
    setEntryToTossUpDataInf({
      ...entryToTossUpDataInf,
      addStatus: "loading",
      contract_id: tableOriginalFunc.key.id as string,
    });
    const { tossUpCategoryNameList, tossUpProductNameList, contract_data } =
      await getContractCopyTossUpAddBefore(
        tableOriginalFunc.key.id,
        entryToTossUpDataInf.changeAccount,
        entryToTossUpDataInf.changeAccountID,
      );
    if (tossUpCategoryNameList.length > 0) {
      setTossUpCategoryNameList(tossUpCategoryNameList);
      setTossUpProductNameList(tossUpProductNameList);
      // 製品選択画面に移行
      setEntryToTossUpDataInf({
        ...entryToTossUpDataInf,
        addStatus: "product",
        contract_id: tableOriginalFunc.key.id as string,
        phone_number: contract_data.customer_phone_number as string,
        customer_name: contract_data.customer_name as string,
        customer_list_id: contract_data.customer_list_id as string,
        customerInfo: contract_data.customer_info as {
          [key: string]: string | string[];
        },
      });
    } else {
      closeEntryToTossUpModal();
      setOnDataAddModalResult(
        "トスアップ可能な商材が定義されていません。管理者に問い合わせてください。",
      );
    }
  }
  function closeEntryToTossUpModal() {
    setEntryToTossUpDataInf({
      addStatus: null,
      contract_id: "",
      toss_up_id: "",
      category_id_list: [],
      product_name_list: [],
      phone_number: "",
      customer_name: "",
      customer_list_id: "",
      hope_call_date: "",
      hope_call_time_kind: null,
      hope_call_time: "12-00",
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setTossUpCategoryNameList([]);
    setTossUpProductNameList([]);
    setEntryToTossUpPostPicture({});
    setEntryToTossUpUniqueOptinList([]);
    setEntryToTossUpAddressOptionName("");
  }
  async function postEntryToTossUpData(customerInfo: {
    [key: string]: string | string[];
  }) {
    const postResponce = await postTossUp({
      ...entryToTossUpDataInf,
      customerInfo,
    });
    if (postResponce === "success") {
      closeEntryToTossUpModal();
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModalResult(postResponce);
      setEntryToTossUpDataInf({
        ...entryToTossUpDataInf,
        addStatus: "toss_up",
      });
    }
  }

  const [entryToEntryDataInf, setEntryToEntryDataInf] = useState<{
    addStatus: string;
    contractId: string;
    changeAccount: number;
    changeAccountID: number | null;
    productId: number | null;
    contractData: any[];
    entryProductList: any[];
    beforeOptionData: any[];
    optionData: any[];
    outSiteEntry: 0 | 1;
    site_path: string;
    outsideMessageType: number | null;
    smsMessagePatternID: number | null;
  }>({
    addStatus: "",
    contractId: "",
    changeAccount: 0,
    changeAccountID: null,
    productId: null,
    contractData: [],
    entryProductList: [],
    beforeOptionData: [],
    optionData: [],
    outSiteEntry: 0,
    site_path: "",
    outsideMessageType: null,
    smsMessagePatternID: null,
  });
  useEffect(() => {
    if (entryToEntryDataInf.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [entryToEntryDataInf]);
  const [customerInfo, setCustomerInfo] = useState<{
    [key: string]: string | string[];
  }>({});
  const [entryToEntryAddData, setEntryToEntryAddData] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success"
      | "confirm";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    outSiteEntry: 0,
    outsideSiteUrl: "",
    outsideServiceUrl: "",
    viewOutsideServiceUrl: 0,
    productId: null,
    productName: "",
    have_entry_form: null,
    site_path_list: [],
    site_path: "",
    outsideMessageType: null,
    phone_number: "",
    customer_name: "",
    customer_company_name: "",
    servicePlanName: "",
    serviceContentNameList: [],
    serviceCampaignPulldownName: "",
    serviceCampaignCheckboxName: [],
    servicePaymentMethodName: "",
    serviseCustomerListID: "",
    pullDownServiceName: "",
    checkBoxServiceNames: "",
    smsMessagePatternID: null,
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  const [entryToEntryAddressOptionName, setEntryToEntryAddressOptionName] =
    useState("");
  // コピーエントリーウィンドウのサービス一覧
  const [
    entryToEntrySelectServisePlanList,
    setEntryToEntrySelectServisePlanList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServiseContentList,
    setEntryToEntrySelectServiseContentList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServiseCampaignPulldownList,
    setEntryToEntrySelectServiseCampaignPulldownList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServiseCampaignCheckboxList,
    setEntryToEntrySelectServiseCampaignCheckboxList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServisePaymentList,
    setEntryToEntrySelectServisePaymentList,
  ] = useState<{ payment_method: string }[]>([]);
  const [entryToEntryUniqueOptinList, setEntryToEntryUniqueOptinList] =
    useState<{ [key: string]: string | number | string[] }[]>([]);
  const [entryToEntryPostPictures, setEntryToEntryPostPictures] = useState<{
    [key: string]: File;
  }>({});
  const [onPostButton, setOnPostButton] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    null,
  );
  const [selectedProductName, setSelectedProductName] = useState<string>("");
  const openEntryToEntryData = async (
    contractId: string,
    changeAccount: number,
    changeAccountID: number | null,
  ) => {
    try {
      setEntryToEntryDataInf((prev) => ({
        ...prev,
        addStatus: "loading",
      }));
      const result = await getContractCopyEntryBefore(
        contractId,
        changeAccount,
        changeAccountID,
      );
      setEntryToEntryDataInf((prev) => ({
        ...prev,
        addStatus: "product",
        contractId,
        changeAccount,
        changeAccountID,
        contractData: result.contract_data,
        entryProductList: result.entryProductList,
        beforeOptionData: result.beforeOptionData,
      }));
    } catch (e) {
      console.error(e);
      setEntryToEntryDataInf((prev) => ({
        ...prev,
        addStatus: "",
      }));
    }
  };
  // ★cmd-po_1209 F1: dead化した旧・複製refetch関数を撤去（cmd-po_1197 step3移設で複製submit経路が ContractCopyEntryModal.postAddContractData へ移り呼出0件のdead codeになっていた。refetchは同モーダルの reloadList prop経由に一本化）
  const closeEntryToEntryModal = () => {
    setEntryToEntryDataInf({
      addStatus: "",
      contractId: "",
      changeAccount: 0,
      changeAccountID: null,
      productId: null,
      contractData: [],
      entryProductList: [],
      beforeOptionData: [],
      optionData: [],
      outSiteEntry: 0,
      site_path: "",
      outsideMessageType: null,
      smsMessagePatternID: null,
    });
    setCustomerInfo({});
    setEntryToEntryAddressOptionName("");
    setEntryToEntryPostPictures({});
    setOnPostButton(false);
    setSelectedProductId(null);
    setSelectedProductName("");
  };

  // 検索項目
  const [serchColumn, setSerchColumn] = useState<{ [key: string]: string }>({});
  const [serchString, setSerchString] = useState<{ [key: string]: string }>({});
  const [serchStringView, setSerchStringView] = useState<{
    [key: string]: string;
  }>({});

  // ソート項目
  const [sortColumn, setSortColumn] = useState<
    {
      key: string;
      sort: string;
    }[]
  >([]);

  // 項目データ読み込み中フラグ
  const [columnLoading, setColumnLoading] = useState(true);

  useEffect(() => {
    if (contractScreenColumn.length > 0) {
      // 検索項目
      const serchColumn = contractScreenColumn.reduce((column, difine) => {
        if (difine.serch === true) {
          if (difine.serchType === "date") {
            return {
              ...column,
              [difine.key + "_start"]: "",
              [difine.key + "_end"]: "",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      }, {});
      setSerchColumn(serchColumn);
      setSerchString(serchColumn);
      setSerchStringView(serchColumn);

      // ソート項目
      const sortColumn = contractScreenColumn
        .filter((column) => {
          return column.sort;
        })
        .map((column) => {
          return {
            key: column.key,
            sort: "DESC",
          };
        })
        .sort((a, b) => {
          if (a.key === "post_date") return -1;
          if (b.key === "post_date") return 1;
          return 0;
        });
      setSortColumn(sortColumn);
      setColumnLoading(false);
    }
  }, [contractScreenColumn]);

  // 顧客一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getContracts(
      {
        ...serchString,
        displayNumber,
        pageNumber,
      },
      sortColumn,
      contractScreenColumn,
    );
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.contracts);
      const countContracts = Number(fetchData.countContracts);
      setTotalCount(countContracts);
      setMaxPageNumber(Math.ceil(countContracts / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
    setFirstLoading(false);
  }
  // 初回データ取得
  useEffect(() => {
    if (firstLoading) {
      getTableData(false);
    }
  }, []);

  // テーブルデータの更新受付
  const [changeTableData, setChangeTableData] = useState(false);

  // 変更があったときのみ
  useEffect(() => {
    if (!firstLoading && changeTableData) {
      getTableData(false);
    } else if (columnLoading === false) {
      setChangeTableData(true);
    }
  }, [serchString, displayNumber, pageNumber, sortColumn]);

  // 顧客詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const service_id = key.service_id;
    const { detail_data, option_data, contract_history } = await getContract(
      id,
      service_id,
    );
    if (detail_data) {
      setDataDetail(detail_data);
      setDataDetailOption(option_data);
      setDataDetailHistory(contract_history);
      setSelectHistory(detail_data.contract_version as number);
      if (!edit) {
        setDetailView(true);
        setDetailBreadcrumb({
          crumb: "日次業務 / エントリー / ",
          title: "エントリー詳細",
        });
      }
    } else {
      setDataDetail(null);
      setDataDetailOption([]);
      setDataDetailHistory([]);
      setSelectHistory(0);
    }
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 詳細（履歴）取得
  async function getOldDataDetail(
    id: string,
    service_plan_id: string,
    contract_version: number,
  ) {
    setIsLoading(true);
    const last_contract_version = dataDetailHistory.reduce(
      (max, item) =>
        item.contract_version > max ? item.contract_version : max,
      dataDetailHistory[0].contract_version,
    );
    if (contract_version === last_contract_version) {
      await getDataDetail({ id, service_id: service_plan_id }, true);
      setIsLoading(false);
      return;
    } else {
      const { detail_data } = await getOldContract(
        id,
        service_plan_id,
        contract_version,
      );
      setDataDetail(detail_data);
      setSelectHistory(contract_version);
      setIsLoading(false);
    }
  }

  // 顧客編集
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      const service_id = editData.service_id as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      if (editData.editType === "customer_picture") {
        if (
          editData.customer_picture &&
          typeof editData.editValue !== "string"
        ) {
          // 顧客情報の画像変更
          const editValue = editData.editValue as {
            [key: string]: string | string[];
          };
          let customer_info = { ...editValue };

          const fileName = editData.customer_picture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", editData.customer_picture);
          // ファイルをS3にアップロード（S3受理確認）
          const r = await postPresignedPost(presigned_object.url, formData);
          if (r !== "seccess") {
            setEditData({ ...editData, status: "before" });
            setIsLoading(false);
            setOnDataAddModalResult("画像のアップロードに失敗しました。もう一度お試しください");
            return;
          }
          customer_info[editData.key] = destination_key;
          const _EditData = {
            ...editData,
            editValue: customer_info,
          };
          const putResponce = await putContract(_EditData);
          await getDataDetail({ id, service_id }, true);
          await getTableData(true);
          await getSubtableDataContractCustomerInfo();
          setEditData({
            ..._EditData,
            status: putResponce,
          });
        }
      } else {
        const putResponce = await putContract(editData);
        await getDataDetail({ id, service_id }, true);
        await getTableData(true);
        await getSubtableDataContractCustomerInfo();
        setEditData({
          ...editData,
          status: putResponce,
        });
      }
      setIsLoading(false);
    }
  }

  // データ無効化
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteContract(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  // 解約
  const [cancelDataInf, setCancelDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    cancellAction: string;
    cancellSmsList: {
      id: number;
      cancell_sms_name: string;
      cancell_sms_type: number;
      cancell_sms_sender: string;
      cancell_sms_body: string;
      cancell_sms_title: string;
      source: "product" | "outside_entry_form";
    }[];
    selectedCancellSms: {
      id: number;
      source: "product" | "outside_entry_form";
    } | null;
    destinationPhoneNumber: string;
    destinationMailAddress: string;
  }>({
    status: null,
    key: {},
    message: "",
    cancellAction: "",
    cancellSmsList: [],
    selectedCancellSms: null,
    destinationPhoneNumber: "",
    destinationMailAddress: "",
  });
  async function cancelData() {
    setCancelDataInf((prev) => ({ ...prev, status: "loading" }));
    const id = cancelDataInf.key.id;
    const responce = await cancellContract(
      id,
      cancelDataInf.selectedCancellSms,
    );
    if (responce == "success") {
      await getTableData(false);
      setCancelDataInf((prev) => ({ ...prev, status: "success" }));
    } else {
      setCancelDataInf((prev) => ({
        ...prev,
        status: "failed",
        message: responce ?? "解約に失敗しました。",
      }));
    }
  }
  useEffect(() => {
    if (cancelDataInf.status === "loading") {
      setIsLoading(true);
    } else if (cancelDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [cancelDataInf]);

  // 個人情報削除
  const [deletePersonDataInf, setDeletePersonDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deletePersonData() {
    setDeletePersonDataInf({
      ...deletePersonDataInf,
      status: "loading",
    });
    const id = deletePersonDataInf.key.id;
    const responce = await deletePersonContract(id);
    if (responce == "success") {
      await getTableData(false);
      if (getSubTableName.name === "顧客情報一覧") {
        setGetSubTableName({
          name: "",
          key: {},
          subData: [],
        });
      }
      setDeletePersonDataInf({
        ...deletePersonDataInf,
        status: "success",
      });
    } else {
      setDeletePersonDataInf({
        ...deletePersonDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deletePersonDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deletePersonDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deletePersonDataInf]);

  // データ登録ウィンドウのサービス一覧
  const [selectServisePlanList, setSelectServisePlanList] = useState<
    { service_name: string }[]
  >([]);
  const [selectServiseContentList, setSelectServiseContentList] = useState<
    { service_name: string }[]
  >([]);
  const [
    selectServiseCampaignPulldownList,
    setSelectServiseCampaignPulldownList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    selectServiseCampaignCheckboxList,
    setSelectServiseCampaignCheckboxList,
  ] = useState<{ service_name: string }[]>([]);
  const [selectServisePaymentList, setSelectServisePaymentList] = useState<
    { payment_method: string }[]
  >([]);
  const [uniqueOptinList, setUniqueOptinList] = useState<
    { [key: string]: string | number | string[] }[]
  >([]);
  const [addressOptionName, setAddressOptionName] = useState("");

  // 画像データ保持用
  const [postPictures, setPostPicture] = useState<{
    [key: string]: File;
  }>({});

  function closeAddModal() {
    setAddData({
      addStatus: null,
      outSiteEntry: 0,
      outsideSiteUrl: "",
      outsideServiceUrl: "",
      viewOutsideServiceUrl: 0,
      productId: null,
      productName: "",
      have_entry_form: null,
      site_path_list: [],
      site_path: "",
      outsideMessageType: null,
      phone_number: "",
      customer_name: "",
      customer_company_name: "",
      servicePlanName: "",
      serviceContentNameList: [],
      serviceCampaignPulldownName: "",
      serviceCampaignCheckboxName: [],
      servicePaymentMethodName: "",
      serviseCustomerListID: "",
      pullDownServiceName: "",
      checkBoxServiceNames: "",
      smsMessagePatternID: null,
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setSelectServisePlanList([]);
    setSelectServiseContentList([]);
    setSelectServiseCampaignPulldownList([]);
    setSelectServiseCampaignCheckboxList([]);
    setSelectServisePaymentList([]);
    setUniqueOptinList([]);
    setContractProductList([]);
    setAddressOptionName("");
    setPostPicture({});
  }

  // 契約情報更新CSV取込
  const [postCSVStatusHeader, setPostCSVStatusHeader] = useState<string[]>([]);
  const [postCSVStatus, setPostCSVStatus] = useState<{
    status:
      | "none"
      | "open"
      | "column"
      | "posting"
      | "result"
      | "loading"
      | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
    destination_key: string;
    product_id: null | number;
    product_key: string;
    header_inf: {
      [key: string]: string;
    };
    error_count: number | null;
    total_count: number | null;
    success_count: number | null;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
    destination_key: "",
    product_id: null,
    product_key: "",
    header_inf: {},
    error_count: null,
    total_count: null,
    success_count: null,
  });
  async function postContractStatusCSV(postDatas: File) {
    setPostCSVStatus({
      ...postCSVStatus,
      status: "loading",
      message: "CSV情報確認中",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    const r = await postPresignedPost(presigned_object.url, formData);
    if (r !== "seccess") {
      setPostCSVStatus({ status: "error", message: "CSVファイルのアップロードに失敗しました。もう一度お試しください。", result: [], header_location: "None", destination_key: "", product_id: null, product_key: "", header_inf: {}, error_count: null, total_count: null, success_count: null });
      return;
    }
    const { headers, csv_column, encoding_error } = await getPostCSVHeader(
      destination_key,
      postCSVStatus.product_id,
    );
    if (encoding_error) {
      setPostCSVStatus({
        ...postCSVStatus,
        status: "error",
        message:
          "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
      });
      return;
    }
    const header_inf = headers.reduce((column, difine) => {
      if (csv_column[difine]) {
        return {
          ...column,
          [difine]: csv_column[difine],
        };
      } else {
        return {
          ...column,
          [difine]: "",
        };
      }
    }, {});
    setPostCSVStatusHeader(headers);
    setPostCSVStatus({
      ...postCSVStatus,
      status: "column",
      message: "CSV情報確認中",
      header_inf,
      destination_key,
    });
  }
  async function startPutContractStatusCSV() {
    setPostCSVStatus({
      ...postCSVStatus,
      status: "posting",
      message: "CSV情報確認中",
    });

    const path = "contractStatus";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: postCSVStatus.destination_key,
      product_id: postCSVStatus.product_id,
      product_key: postCSVStatus.product_key,
      header_inf: postCSVStatus.header_inf,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.inputCSVContractStatusWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVStatus({
          ...postCSVStatus,
          status: "loading",
          message:
            decodedData.header_location !== "None"
              ? "CSV取込完了。エラー内容をダウンロードして確認してください。"
              : "CSV取込完了",
          result: postCSVStatus.result,
          header_location: decodedData.header_location,
          error_count: decodedData.error_count ?? postCSVStatus.error_count,
          total_count: decodedData.total_count ?? postCSVStatus.total_count,
          success_count: decodedData.success_count ?? postCSVStatus.success_count,
        });
        await getTableData(true);
        setPostCSVStatus({
          ...postCSVStatus,
          status: "result",
          message:
            decodedData.header_location !== "None"
              ? "CSV取込完了。エラー内容をダウンロードして確認してください。"
              : "CSV取込完了",
          result: postCSVStatus.result,
          header_location: decodedData.header_location,
          error_count: decodedData.error_count ?? postCSVStatus.error_count,
          total_count: decodedData.total_count ?? postCSVStatus.total_count,
          success_count: decodedData.success_count ?? postCSVStatus.success_count,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVStatus({
          ...postCSVStatus,
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
        });
        websocket.close();
      } else if (decodedData.message === "encoding_error") {
        setPostCSVStatus({
          ...postCSVStatus,
          status: "error",
          message:
            "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostCSVStatus({
          ...postCSVStatus,
          status: "posting",
          message: decodedData.message,
          result: _result,
          error_count: decodedData.error_count ?? postCSVStatus.error_count,
          total_count: decodedData.total_count ?? postCSVStatus.total_count,
          success_count: decodedData.success_count ?? postCSVStatus.success_count,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 契約サービスCSV更新取込
  const [putCSVContractService, setPutCSVContractService] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  async function putContractServiceCSV(postDatas: File) {
    setPutCSVContractService({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    const r = await postPresignedPost(presigned_object.url, formData);
    if (r !== "seccess") {
      setPutCSVContractService({ status: "error", message: "CSVファイルのアップロードに失敗しました。もう一度お試しください。", result: [], header_location: "None" });
      return;
    }

    setPutCSVContractService({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "contractService";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPutCSVContractService({
          status: "loading",
          message: "CSV取込完了",
          result: putCSVContractService.result,
          header_location: decodedData.header_location,
        });
        await getTableData(true);
        if (getSubTableName.name === "コンテンツ一覧") {
          await getSubtableDataContractServiceContent();
        }
        setPutCSVContractService({
          status: "result",
          message: "CSV取込完了",
          result: putCSVContractService.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPutCSVContractService({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (decodedData.message === "encoding_error") {
        setPutCSVContractService({
          status: "error",
          message:
            "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = putCSVContractService.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPutCSVContractService({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 営業アカウント更新CSV取込
  const [postCSVSaleAccount, setPostCSVSaleAccount] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  async function postContractSaleAccountCSV(postDatas: File) {
    setPostCSVSaleAccount({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    const r = await postPresignedPost(presigned_object.url, formData);
    if (r !== "seccess") {
      setPostCSVSaleAccount({ status: "error", message: "CSVファイルのアップロードに失敗しました。もう一度お試しください。", result: [], header_location: "None" });
      return;
    }

    setPostCSVSaleAccount({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "contractSaleAccount";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVSaleAccount({
          status: "loading",
          message: "CSV取込完了",
          result: postCSVSaleAccount.result,
          header_location: decodedData.header_location,
        });
        await getTableData(true);
        setPostCSVSaleAccount({
          status: "result",
          message: "CSV取込完了",
          result: postCSVSaleAccount.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVSaleAccount({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (decodedData.message === "encoding_error") {
        setPostCSVSaleAccount({
          status: "error",
          message:
            "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVSaleAccount.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostCSVSaleAccount({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 申込番号更新CSV取込
  const [postCSVContractNumber, setPostCSVContractNumber] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  async function postContractNumberCSV(postDatas: File) {
    setPostCSVContractNumber({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    const r = await postPresignedPost(presigned_object.url, formData);
    if (r !== "seccess") {
      setPostCSVContractNumber({ status: "error", message: "CSVファイルのアップロードに失敗しました。もう一度お試しください。", result: [], header_location: "None" });
      return;
    }

    setPostCSVContractNumber({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "contractNumber";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVContractNumber({
          status: "loading",
          message: "CSV取込完了",
          result: postCSVContractNumber.result,
          header_location: decodedData.header_location,
        });
        await getTableData(true);
        setPostCSVContractNumber({
          status: "result",
          message: "CSV取込完了",
          result: postCSVContractNumber.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVContractNumber({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (decodedData.message === "encoding_error") {
        setPostCSVContractNumber({
          status: "error",
          message:
            "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVContractNumber.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostCSVContractNumber({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 契約事前一括取込
  const [postContractCSVStatus, setPostContractCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  async function postContractCSV(postDatas: File) {
    setPostContractCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    const r = await postPresignedPost(presigned_object.url, formData);
    if (r !== "seccess") {
      setPostContractCSVStatus({ status: "error", message: "CSVファイルのアップロードに失敗しました。もう一度お試しください。", result: [], header_location: "None" });
      return;
    }

    setPostContractCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "addContract";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostContractCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postContractCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getProductList();
        await getTableData(true);
        setPostContractCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postContractCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostContractCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (decodedData.message === "encoding_error") {
        setPostContractCSVStatus({
          status: "error",
          message:
            "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postContractCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostContractCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // CSV一括エントリー
  const [postCSVEntryContract, setPostCSVEntryContract] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({ status: "none", message: "", result: [], header_location: "None" });
  async function postEntryContractCSV(postDatas: File) {
    setPostCSVEntryContract({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    const formData = new FormData();
    for (const key in presigned_object.fields)
      formData.append(key, presigned_object.fields[key]);
    formData.append("file", postDatas);
    const r = await postPresignedPost(presigned_object.url, formData);
    if (r !== "seccess") {
      setPostCSVEntryContract({ status: "error", message: "CSVファイルのアップロードに失敗しました。もう一度お試しください。", result: [], header_location: "None" });
      return;
    }
    setPostCSVEntryContract({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: "entryContract",
      destination_key,
      idToken,
    };
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVEntryContract({
          status: "loading",
          message: "CSV取込完了",
          result: postCSVEntryContract.result,
          header_location: decodedData.header_location,
        });
        await getTableData(true);
        setPostCSVEntryContract({
          status: "result",
          message: "CSV取込完了",
          result: postCSVEntryContract.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVEntryContract({
          ...postCSVEntryContract,
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
        });
        websocket.close();
      } else if (decodedData.message === "encoding_error") {
        setPostCSVEntryContract({
          ...postCSVEntryContract,
          status: "error",
          message:
            "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVEntryContract.result;
        if (decodedData.res_results) _result.push(decodedData.res_results);
        setPostCSVEntryContract({
          ...postCSVEntryContract,
          status: "posting",
          message: decodedData.message,
          result: _result,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 明細Excel取得 (cmd-po_1393: データ系facet退役=merge_sheetのみ残置)
  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    merge_sheet: boolean;
  }>({
    status: "none",
    message: "",
    merge_sheet: false,
  });

  async function getPaymentsXLSX() {
    const idToken = loginUser?.idToken;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}_${hours}${minutes}${seconds}`;
    const fileName = "契約一覧_" + nowTimeName + ".xlsx";
    const bodys = {
      type: "get_xlsx_contract",
      sale_company_id: null,
      sale_company_name: "",
      all_company: true,
      product_ids: [],
      product_names: [],
      all_product: true,
      merge_sheet: getXLSXStatus.merge_sheet,
      // cmd-po_1393: 一覧検索条件透過（1b-BE cmd-1392が読むkey名 search_params に一致）
      search_params: serchString,
      idToken,
      fileName,
    };
    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.outputXLSXContractsWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // cmd-po_1269: 無限ローディング解消。成功前の切断/3分無進捗で失敗状態へ遷移しspinnerを解除する。
    let succeeded = false;
    let noProgressTimer: ReturnType<typeof setTimeout> | null = null;
    const NO_PROGRESS_MS = 3 * 60 * 1000; // 3分無進捗=失敗扱い
    const clearNoProgressTimer = () => {
      if (noProgressTimer !== null) {
        clearTimeout(noProgressTimer);
        noProgressTimer = null;
      }
    };
    const failXLSX = () => {
      if (succeeded) return; // 成功済みなら何もしない（成功closeのonclose含む）
      clearNoProgressTimer();
      setGetXLSXStatus((prev) => ({
        ...prev,
        status: "error",
        message: "出力に失敗しました。再度お試しください",
      }));
      try {
        websocket.close();
      } catch (e) {
        // close済み等は無視
      }
    };
    const armNoProgressTimer = () => {
      clearNoProgressTimer();
      noProgressTimer = setTimeout(failXLSX, NO_PROGRESS_MS);
    };
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      armNoProgressTimer(); // 進捗受信のたびにタイマをリセット
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        succeeded = true;
        clearNoProgressTimer();
        const url = decodedData.url;
        const link = document.createElement("a");
        link.href = decodedData.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode?.removeChild(link);

        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "result",
          message: "",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "getting",
          message: decodedData.message,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => {
      armNoProgressTimer(); // 送信開始でタイマ起動（開通後に無進捗のまま放置される事故も検知）
      websocket.send(JSON.stringify(bodys));
    };
    // 成功前に接続が切れたら失敗表示＋spinner解除（無限ローディング防止）。成功時のcloseはsucceededガードでno-op
    websocket.onclose = () => {
      failXLSX();
    };
  }

  // 契約新規登録
  async function postAddData(customerInfo: {
    [key: string]: string | string[];
  }) {
    if (addData.outSiteEntry == 0) {
      const postResponce = await postContract({ ...addData, customerInfo });
      if (postResponce === "success") {
        await getTableData(true);
        getProductNameListFromHistory();
        closeAddModal();
        setOnDataAddModalResult("success");
      } else {
        setOnDataAddModalResult(postResponce);
        setAddData({
          ...addData,
          addStatus: "contract",
        });
      }
    } else if (addData.outSiteEntry == 1) {
      let mail_address = "@";
      uniqueOptinList.map((uniqueOptin) => {
        if (uniqueOptin.mail_address_flg === 1) {
          mail_address = addData.customerInfo[
            uniqueOptin.option_name as string
          ] as string;
        }
      });
      if (mail_address === "@" && addData.customerInfo["メールアドレス"]) {
        mail_address = addData.customerInfo["メールアドレス"] as string;
      }

      const {
        postResponce,
        outsideSiteUrl,
        outsideServiceUrl,
        viewOutsideServiceUrl,
      } = await postContractShortMessage(
        {
          ...addData,
          customerInfo,
        },
        mail_address,
        "",
        "",
      );
      if (postResponce === "success") {
        setAddData({
          ...addData,
          addStatus: "sms_success",
          outsideSiteUrl,
          outsideServiceUrl,
          viewOutsideServiceUrl,
        });
      } else {
        setOnDataAddModalResult(postResponce);
        setAddData({
          ...addData,
          addStatus: "contract",
        });
      }
    }
  }

  // コンテンツ一覧取得
  async function getSubtableDataContractServiceContent() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getContractServiceContents(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 顧客情報一覧取得
  async function getSubtableDataContractCustomerInfo() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const { sudDatas, option_data } = await getContractCustomerInfos(
        getSubTableName.key.id,
      );
      const fetchData = option_data.map((option) => {
        return {
          ...option,
          id: sudDatas[0]["contract_id"],
          product_id: sudDatas[0]["product_id"],
          customer_info: sudDatas[0]["customer_info"],
          customer_info_key: option.option_name,
          customer_info_value: sudDatas[0]["customer_info"][option.option_name],
        };
      });
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData,
      });
      setIsLoading(false);
    }
  }

  // 顧客情報ダイレクト編集
  const [editDataContractCustomerInfo, setEditDataContractCustomerInfo] =
    useState<EditDataDifine | null>(null);
  async function putEditSubtableDataDirectContractCustomerInfo() {
    if (editDataContractCustomerInfo !== null) {
      setIsLoading(true);
      setEditDataContractCustomerInfo({
        ...editDataContractCustomerInfo,
        status: "editing",
      });

      if (editDataContractCustomerInfo.editType === "customer_picture") {
        if (
          editDataContractCustomerInfo.customer_picture &&
          typeof editDataContractCustomerInfo.editValue !== "string"
        ) {
          // 顧客情報の画像変更
          const editValue = editDataContractCustomerInfo.editValue as {
            [key: string]: string | string[];
          };
          let customer_info = { ...editValue };

          const fileName = editDataContractCustomerInfo.customer_picture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append(
            "file",
            editDataContractCustomerInfo.customer_picture,
          );
          // ファイルをS3にアップロード
          const r = await postPresignedPost(presigned_object.url, formData);
          if (r !== "seccess") {
            setEditDataContractCustomerInfo({
              ...editDataContractCustomerInfo,
              status: "before",
            });
            setIsLoading(false);
            setOnDataAddModalResult(
              "画像のアップロードに失敗しました。もう一度お試しください",
            );
            return;
          }
          customer_info[editDataContractCustomerInfo.key] = destination_key;
          const _editDataContractCustomerInfo = {
            ...editDataContractCustomerInfo,
            editValue: customer_info,
          };
          const putResponce = await putContractCustomerInfo(
            _editDataContractCustomerInfo,
          );
          await getTableData(true);
          await getSubtableDataContractCustomerInfo();
          setEditDataContractCustomerInfo({
            ..._editDataContractCustomerInfo,
            status: putResponce,
          });
        }
      } else {
        const putResponce = await putContractCustomerInfo(
          editDataContractCustomerInfo,
        );
        if (putResponce == "success") {
          await getTableData(true);
          await getSubtableDataContractCustomerInfo();
        }
        setEditDataContractCustomerInfo({
          ...editDataContractCustomerInfo,
          status: putResponce,
        });
      }
      setIsLoading(false);
    }
  }

  // 契約情報一覧取得
  async function getSubtableDataContractContractInfo() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getContractContractInfos(getSubTableName.key.id);
      const contractInfo = fetchData.sudDatas[0].contract_info as {
        [key: string]: string;
      };
      const contractInfoKeys = Object.keys(contractInfo);
      const subData = contractInfoKeys.map((key) => {
        return {
          contract_info_key: key,
          contract_info_value: contractInfo[key],
        };
      });
      setGetSubTableName({
        ...getSubTableName,
        subData,
      });
      setIsLoading(false);
    }
  }

  // 契約情報項目削除
  const [deleteContractInfoDataInf, setDeleteContractInfoDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteContractInfoData() {
    setDeleteContractInfoDataInf({
      ...deleteContractInfoDataInf,
      status: "loading",
    });
    const responce = await deleteContractContractInfo(
      getSubTableName.key.id,
      deleteContractInfoDataInf.key.infoKey,
    );
    if (responce === "success") {
      await getTableData(false);
      await getSubtableDataContractContractInfo();
      setDeleteContractInfoDataInf({
        ...deleteContractInfoDataInf,
        status: "success",
      });
    } else {
      setDeleteContractInfoDataInf({
        ...deleteContractInfoDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteContractInfoDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteContractInfoDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteContractInfoDataInf]);

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }
  // 商材一覧
  const [productList, setProductList] = useState<
    {
      id: number;
      high_rank_company_id: number;
      product_name: string;
      high_rank_company_name: string;
      product_key: string;
    }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
          high_rank_company_name: string;
          product_key: string;
        }[],
      );
    }
  }
  async function getProductNameListFromHistory() {
    const products = await getProductCandidatesEntry();
    if (products) {
      const names: string[] = [""];
      for (const p of products) {
        if (p.product_name && !names.includes(p.product_name)) {
          names.push(p.product_name);
        }
      }
      setProductNameList(names);
    }
  }

  // グループ一覧取得
  const [searchGroupList, setSearchGroupList] = useState<
    {
      id: number;
      group_name: string;
      sale_company_id: number;
    }[]
  >([]);
  const [searchGroupNameList, setSearchGroupNameList] = useState([""]);
  async function getSaleCompanyGroupsList() {
    const fetchData = await getSerchSaleCompanyGroups();
    if (fetchData === null) {
      setSearchGroupList([]);
    } else if (fetchData) {
      setSearchGroupList(
        fetchData.saleCompanyGroups as {
          id: number;
          group_name: string;
          sale_company_id: number;
        }[],
      );
      let searchGroupNameList = [""];
      fetchData.saleCompanyGroups.map(
        (company: { id: number; group_name: string }) => {
          if (!searchGroupNameList.includes(company.group_name)) {
            searchGroupNameList.push(company.group_name);
          }
        },
      );
      setSearchGroupNameList(searchGroupNameList);
    }
  }

  // 営業アカウント一覧
  const [accountSaleList, setAccountSaleList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountSaleNameList, setAccountSaleNameList] = useState([""]);
  async function getSaleAccountSalesList() {
    const fetchData = await getSerchAccountSales();
    if (fetchData === null) {
      setAccountSaleList([]);
    } else if (fetchData) {
      setAccountSaleList(
        fetchData.accountSales as { id: number; account_name: string }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountSales.map(
        (accountSale: { id: number; account_name: string }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountSaleNameList(accountSaleNameList);
    }
  }
  // 協業営業アカウント一覧
  const [
    accountCollaborateCompanySaleList,
    setAccountCollaborateCompanySaleList,
  ] = useState<
    {
      sale_company_id: number;
      sale_company_name: string;
      id: number;
      account_name: string;
    }[]
  >([]);
  const [
    accountCollaborateCompanySaleNameList,
    setAccountCollaborateCompanySaleNameList,
  ] = useState([""]);
  async function getCollaborateCompanySaleAccountSalesList() {
    const fetchData = await getSerchAccountCollaborateCompanys();
    if (fetchData === null) {
      setAccountCollaborateCompanySaleList([]);
    } else if (fetchData) {
      setAccountCollaborateCompanySaleList(
        fetchData.accountCollaborateCompanySales as {
          sale_company_id: number;
          sale_company_name: string;
          id: number;
          account_name: string;
        }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountCollaborateCompanySales.map(
        (accountSale: {
          sale_company_id: number;
          sale_company_name: string;
          id: number;
          account_name: string;
        }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountCollaborateCompanySaleNameList(accountSaleNameList);
    }
  }
  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getSaleCompanysList();
    getSaleCompanyGroupsList();
    getProductList();
    getProductNameListFromHistory();
    getSaleAccountSalesList();
    getCollaborateCompanySaleAccountSalesList();
  }, []);

  // cmd-po_1168 SP排他: AI open時に検索を close
  useEffect(() => {
    if (aiChatOpen && isSmartPhone) setSerchOpen(false);
  }, [aiChatOpen, isSmartPhone]);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open && isSmartPhone) setAiChatOpenAtom(false);
  };

  return (
    <Box
      data-testid="contract-page"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "var(--sp-2, 8px)",
          alignItems: "stretch",
          flex: 1,
          minHeight: 0,
        }}
      >
        {detailView && dataDetail ? (
          /* ─── 詳細ページビュー ─── */
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              maxHeight: "100%",
            }}
          >
            <Box
              data-testid="detail-header"
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                flexWrap: "wrap",
                gap: 1,
                flexShrink: 0,
              }}
            >
              <IconButton
                size="small"
                onClick={closeDetailView}
                aria-label="一覧に戻る"
                sx={{ mr: 0.5 }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, fontSize: 20, color: "text.primary" }}
              >
                {dataDetail["customer_name"] as string}
              </Typography>
              <Chip
                label={dataDetail["contract_state"] as string}
                size="small"
                sx={{
                  bgcolor: "var(--color-ai-pale, #e8eef4)",
                  color: "var(--color-ai, #1e3a5f)",
                  fontWeight: 600,
                  ml: 0.5,
                }}
              />
              <Box
                sx={{
                  ml: "auto",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {dataDetailHistory.length > 0 && (
                  <FormControl size="small">
                    <Select
                      value={selectHistory}
                      onChange={(e) =>
                        getOldDataDetail(
                          dataDetail.id as string,
                          dataDetail.service_id as string,
                          e.target.value as number,
                        )
                      }
                      sx={{ fontSize: "14px", minWidth: "140px" }}
                    >
                      {dataDetailHistory.map((h, i) => (
                        <MenuItem
                          key={"hist" + i}
                          value={h.contract_version}
                          sx={{ fontSize: "14px" }}
                        >
                          更新履歴: {h.selected_date}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            </Box>
            {dataDetailHistory.length > 0 &&
              selectHistory !== lastContractVersion && (
                <Alert
                  severity="info"
                  sx={{ mb: 2 }}
                  action={
                    <Button
                      size="small"
                      onClick={() =>
                        getOldDataDetail(
                          dataDetail["id"] as string,
                          dataDetail["service_id"] as string,
                          lastContractVersion,
                        )
                      }
                    >
                      最新に戻る
                    </Button>
                  }
                >
                  {dataDetailHistory.find(
                    (h) => h.contract_version === selectHistory,
                  )?.selected_date ?? ""}
                  時点の内容を表示中
                </Alert>
              )}
            {/* アクションボタンバー（「今押せるボタンのみ」原則） */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 2,
                p: "10px 16px",
                border: "1px solid var(--color-border, #e5e5e0)",
                borderRadius: "var(--radius-md, 10px)",
                bgcolor: "background.paper",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mr: 1, fontSize: 13 }}
              >
                今押せる操作
              </Typography>
              {(() => {
                const facts = detailToFacts(dataDetail);
                const ctx = { pathname: "/contract" };
                const detailKey = {
                  id: String(dataDetail["id"]),
                  product_id: String(dataDetail["product_id"]),
                  service_id: String(dataDetail["service_id"]),
                  cancell_action: String(dataDetail["cancell_action"] ?? ""),
                };
                return (
                  <>
                    {contractTableColumn.tableFunction
                      .filter(
                        (tf) =>
                          loginUser &&
                          tf.auth.includes(loginUser.authority) &&
                          tf.displayScope === "list_and_detail",
                      )
                      .map((tf) => (
                        <Button
                          key={tf.name}
                          variant="outlined"
                          size="small"
                          disabled={isTableFunctionDisabled(
                            tf.name,
                            facts,
                            ctx,
                          )}
                          sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                          onClick={() =>
                            setTableOriginalFunc({
                              name: tf.name,
                              key: detailKey,
                            })
                          }
                        >
                          {tf.name}
                        </Button>
                      ))}
                  </>
                );
              })()}
            </Box>
            {/* 詳細テーブル */}
            <DataDetailTable
              editAuth={contractTableColumn.editAuth}
              dataColumn={contractScreenColumn}
              subDataColumn={[]}
              dataDetail={dataDetail}
              setEditData={setEditData}
              dataDetailOption={dataDetailOption}
              dataDetailOptionSelect={[]}
              dataDetailHistory={dataDetailHistory}
              detailTitle={contractTableColumn.detailTitle}
              getGroupList={() => {}}
              setSelectServiseInfo={setSelectServiseInfo}
              setSelectTossUpInfo={() => {}}
              contractInfoRows={detailContractInfos.map((info) => ({
                key: info.contract_info_key,
                value: info.contract_info_value,
              }))}
            />
          </Box>
        ) : (
          <>
            {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  maxHeight: "100%",
                }}
              >
                <TableTopBar
                  serch={true}
                  serchOpen={serchOpen}
                  setSerchOpen={handleSetSerchOpen}
                  addDataNames={addDataNames}
                  addDataName={addDataName}
                  setAddDataName={setAddDataName}
                  addCSVDataNames={addCSVDataNames}
                  addCSVDataName={addCSVDataName}
                  setAddCSVDataName={setAddCSVDataName}
                  getXLSXDataNames={getXLSXDataNames}
                  getXLSXDataName={getXLSXDataName}
                  setGetXLSXDataName={setGetXLSXDataName}
                  editDatasNames={editDatasNames}
                  editDatasName={editDatasName}
                  setEditDatasName={setEditDatasName}
                  editIDs={[]}
                  columnSettingOpen={columnSetting.status !== "none"}
                  openColumnSettingWindow={openColumnSettingWindow}
                    totalCount={totalCount}
                  onReload={() => getTableData(false)}
                />
                <ConstTable
                  emptyState={
                    <EmptyState
                      isSearchActive={Object.keys(serchString).some(
                        (k) => serchString[k] !== serchColumn[k],
                      )}
                      onClearSearch={() => {
                        setSerchString(serchColumn);
                        setSerchStringView(serchColumn);
                      }}
                      canAdd={addDataNames.includes("エントリー")}
                      onAdd={() => setAddDataName("エントリー")}
                      entityLabel="エントリー"
                    />
                  }
                  getTableData={getTableData}
                  tableType={"main"}
                  serch={true}
                  setSerchOpen={handleSetSerchOpen}
                  serchOpen={serchOpen}
                  tableColumn={contractTableColumn}
                  dataColumn={contractScreenColumn}
                  rows={fetchData}
                  displayNumber={displayNumber}
                  setDisplayNumber={setDisplayNumber}
                  displayNumbers={displayNumbers}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  maxPageNumber={maxPageNumber}
                  totalCount={totalCount}
                  getDataDetail={getDataDetail}
                  getSubTableName={getSubTableName}
                  setGetSubTableName={setGetSubTableName}
                  getSubTableDetail={{ name: "", key: {}, dataDetail: null }}
                  setGetSubTableDetail={() => {}}
                  setGetSubTableAdd={() => {}}
                  setGetSubTableEditDirect={setEditDataContractCustomerInfo}
                  getSubSubTableName={{ name: "", key: {}, subData: [] }}
                  setGetSubSubTableName={() => {}}
                  getSubSubTableDetail={{ name: "", key: {}, dataDetail: null }}
                  setGetSubSubTableDetail={() => {}}
                  setGetSubSubTableAdd={() => {}}
                  setGetSubSubTableEditDirect={() => {}}
                  tableTitle={contractTableColumn.title}
                  switchTableCheckBox={() => {}}
                  allCheckFlg={false}
                  switchAllTableCheckBox={() => {}}
                  editIDs={[]}
                  setEditIDs={() => {}}
                  setEditDatasName={setEditDatasName}
                  setTableOriginalFunc={setTableOriginalFunc}
                  sortColumn={sortColumn}
                  setSortColumn={setSortColumn}
                />
              </Box>
            )}
            {serchOpen ? (
              <SerchSideBar
                setSerchOpen={handleSetSerchOpen}
                tableColumn={contractTableColumn}
                dataColumn={contractScreenColumn}
                firstYear={firstYear}
                thisYear={thisYear}
                serchColumn={serchColumn}
                setSerchString={setSerchString}
                companyNameList={companyNameList}
                companyGroupNameList={searchGroupNameList}
                highRankCompanyNameList={highRankCompanyNameList}
                categoryNameList={categoryNameList}
                productNameList={productNameList}
                accountSaleNameList={accountSaleNameList}
                accountStaffNameList={[]}
                serchStringView={serchStringView}
                setSerchStringView={setSerchStringView}
              />
            ) : null}
          </>
        )}
      </Box>
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => {
          setEditData(null);
          setSelectServiseInfo({
            service_plan_data: [],
            service_content_data: [],
            service_campaign_pulldown_data: [],
            service_campaign_checkbox_data: [],
          });
        }}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        selectServiseInfo={selectServiseInfo}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataContractCustomerInfo !== null &&
          editDataContractCustomerInfo.status !== "editing"
        }
        swCloseModal={() => setEditDataContractCustomerInfo(null)}
        editData={editDataContractCustomerInfo}
        setEditData={setEditDataContractCustomerInfo}
        putEditData={putEditSubtableDataDirectContractCustomerInfo}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <ChangeAccountCollaborateModal
        onModal={addData.addStatus === "change_account"}
        swCloseModal={() => {
          closeAddModal();
          setAddDataName("");
        }}
        changeAccount={addData.changeAccount}
        changeAccountID={addData.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setAddData({
            ...addData,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setAddData({
            ...addData,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"エントリー登録"}
        steps={["担当アカウント", "商材選択", "情報入力"]}
        getFormFunction={getContractProductList}
        accountColumn={"営業担当アカウント"}
      />
      <ContractAddModal
        onModal={
          addData.addStatus !== null &&
          addData.addStatus !== "loading" &&
          addData.addStatus !== "change_account"
        }
        swCloseModal={() => {
          closeAddModal();
          setAddDataName("");
        }}
        tableColumn={contractTableColumn}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        contractProductList={contractProductList}
        firstYear={firstYear}
        thisYear={thisYear}
        selectServisePlanList={selectServisePlanList}
        setSelectServisePlanList={setSelectServisePlanList}
        selectServiseContentList={selectServiseContentList}
        setSelectServiseContentList={setSelectServiseContentList}
        selectServiseCampaignPulldownList={selectServiseCampaignPulldownList}
        setSelectServiseCampaignPulldownList={
          setSelectServiseCampaignPulldownList
        }
        selectServiseCampaignCheckboxList={selectServiseCampaignCheckboxList}
        setSelectServiseCampaignCheckboxList={
          setSelectServiseCampaignCheckboxList
        }
        selectServisePaymentList={selectServisePaymentList}
        setSelectServisePaymentList={setSelectServisePaymentList}
        uniqueOptinList={uniqueOptinList}
        setUniqueOptinList={setUniqueOptinList}
        addressOptionName={addressOptionName}
        setAddressOptionName={setAddressOptionName}
        postPictures={postPictures}
        setPostPicture={setPostPicture}
        setOnDataAddModalResult={setOnDataAddModalResult}
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        accountColumn={"営業担当アカウント"}
        getFormFunction={getContractProductList}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <PostCSVContractStatusModal
        onModal={
          postCSVStatus.status !== "none"
        }
        swCloseModal={() => {
          setPostCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
            destination_key: "",
            product_id: null,
            product_key: "",
            header_inf: {},
            error_count: null,
            total_count: null,
            success_count: null,
          });
          setAddCSVDataName("");
          setPostCSVStatusHeader([]);
        }}
        postCSVStatus={postCSVStatus}
        setPostCSVStatus={setPostCSVStatus}
        postCSVFunc={postContractStatusCSV}
        startPutCSVFunc={startPutContractStatusCSV}
        postCSVTitle={"契約情報取込"}
        productList={productList}
        postCSVStatusHeader={postCSVStatusHeader}
      />
      <PostCSVModal
        onModal={
          putCSVContractService.status !== "none"
        }
        swCloseModal={() => {
          setPutCSVContractService({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={putCSVContractService}
        setPostCSVStatus={setPutCSVContractService}
        postCSVFunc={putContractServiceCSV}
        postCSVTitle={"契約サービスCSV更新取込"}
        postCSVColumn={putCSVColumnContractService}
        postCSVColumnResult={putCSVColumnContractServiceResult}
        postCSVPath="contractService"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postCSVSaleAccount.status !== "none"
        }
        swCloseModal={() => {
          setPostCSVSaleAccount({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postCSVSaleAccount}
        setPostCSVStatus={setPostCSVSaleAccount}
        postCSVFunc={postContractSaleAccountCSV}
        postCSVTitle={"営業アカウント更新CSV取込"}
        postCSVColumn={putCSVColumnSaleAccount}
        postCSVColumnResult={putCSVColumnSaleAccount.map((c) => c.name)}
        postCSVPath="contractSaleAccount"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postCSVContractNumber.status !== "none"
        }
        swCloseModal={() => {
          setPostCSVContractNumber({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postCSVContractNumber}
        setPostCSVStatus={setPostCSVContractNumber}
        postCSVFunc={postContractNumberCSV}
        postCSVTitle={"申込番号CSV取込"}
        postCSVColumn={putCSVColumnContractNumber}
        postCSVColumnResult={putCSVColumnContractNumber.map((c) => c.name)}
        postCSVPath="contractNumber"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postContractCSVStatus.status !== "none"
        }
        swCloseModal={() => {
          setPostContractCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postContractCSVStatus}
        setPostCSVStatus={setPostContractCSVStatus}
        postCSVFunc={postContractCSV}
        postCSVTitle={"契約情報事前取込"}
        postCSVColumn={postCSVColumnAdminContract}
        postCSVColumnResult={postCSVColumnAdminContractResult}
        postCSVPath="addContract"
        productList={productList}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postCSVEntryContract.status !== "none"
        }
        swCloseModal={() => {
          setPostCSVEntryContract({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postCSVEntryContract}
        setPostCSVStatus={setPostCSVEntryContract}
        postCSVFunc={postEntryContractCSV}
        postCSVTitle={"CSV一括エントリー"}
        postCSVColumn={postCSVColumnEntryContract}
        postCSVExtraChips={postCSVColumnEntryContractExtraChips}
        postCSVColumnResult={postCSVColumnEntryContractResult}
        postCSVPath="entryContract"
        productList={productList}
        categoryList={[]}
      />
      <GetXLSXContractModal
        onModal={getXLSXStatus.status !== "none"}
        swCloseModal={() => {
          // cmd-po_1393: 退役fields削除=merge_sheetのみリセット
          setGetXLSXStatus({
            status: "none",
            message: "",
            merge_sheet: false,
          });
          setGetXLSXDataName("");
        }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getPaymentsXLSX}
        totalCount={totalCount}
      />
      <DataDeleteModal
        onModal={
          deleteDataInf.status !== null && deleteDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteDataInf}
        setDeleteDataInf={setDeleteDataInf}
        deleteData={deleteData}
        labels={{
          title: "エントリー取消",
          confirmBody: (
            <Alert severity="error">
              エントリー取消後、データは復元できません。
              <br />
              誤って登録をしたエントリーのみ取消を実施してください。
            </Alert>
          ),
          confirmButtonLabel: "エントリー取消",
          successMessage: "エントリーの削除に成功しました。",
        }}
      />
      <DataDeleteModal
        onModal={
          deleteContractInfoDataInf.status !== null &&
          deleteContractInfoDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteContractInfoDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({ name: "", key: {} });
        }}
        deleteDataInf={deleteContractInfoDataInf}
        setDeleteDataInf={setDeleteContractInfoDataInf}
        deleteData={deleteContractInfoData}
        labels={{
          title: "契約情報項目の削除",
          confirmBody: (
            <Alert severity="error">
              項目「{deleteContractInfoDataInf.key.infoKey}
              」を削除します。削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "削除",
          successMessage: "契約情報項目の削除に成功しました。",
        }}
      />
      <PersonDataDeleteModal
        onModal={
          deletePersonDataInf.status !== null &&
          deletePersonDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeletePersonDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePersonDataInf={deletePersonDataInf}
        setDeletePersonDataInf={setDeletePersonDataInf}
        deletePersonData={deletePersonData}
      />
      <DataCancelModal
        onModal={
          cancelDataInf.status !== null && cancelDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setCancelDataInf({
            status: null,
            key: {},
            message: "",
            cancellAction: "",
            cancellSmsList: [],
            selectedCancellSms: null,
            destinationPhoneNumber: "",
            destinationMailAddress: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        cancelDataInf={cancelDataInf}
        setCancelDataInf={setCancelDataInf}
        cancelData={cancelData}
      />
      <ChangeAccountCollaborateModal
        onModal={entryToTossUpDataInf.addStatus === "change_account"}
        swCloseModal={() => {
          closeEntryToTossUpModal();
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        changeAccount={entryToTossUpDataInf.changeAccount}
        changeAccountID={entryToTossUpDataInf.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setEntryToTossUpDataInf({
            ...entryToTossUpDataInf,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setEntryToTossUpDataInf({
            ...entryToTossUpDataInf,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"トスアップ複製"}
        getFormFunction={openEntryToTossUp}
        // cmd-po_1212(D2-b): 複製flow担当アカウントstepのステッパー復旧=ContractAd方式(steps prop付与)忠実コピー。写す元=後続ContractCopyTossUpModal:946 change_account枝の実配列。steps以外は不触。
        steps={["担当アカウント", "商材選択", "情報入力"]}
        accountColumn={"トスアップアカウント"}
      />
      <ContractCopyTossUpModal
        onModal={
          entryToTossUpDataInf.addStatus !== null &&
          entryToTossUpDataInf.addStatus !== "loading" &&
          entryToTossUpDataInf.addStatus !== "change_account"
        }
        swCloseModal={() => {
          closeEntryToTossUpModal();
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        postAddData={postEntryToTossUpData}
        addData={entryToTossUpDataInf}
        setAddData={setEntryToTossUpDataInf}
        uniqueOptinList={entryToTossUpUniqueOptinList}
        setUniqueOptinList={setEntryToTossUpUniqueOptinList}
        addressOptionName={entryToTossUpAddressOptionName}
        setAddressOptionName={setEntryToTossUpAddressOptionName}
        postPictures={entryToTossUpPostPictures}
        setPostPicture={setEntryToTossUpPostPicture}
        tossUpCategoryNameList={tossUpCategoryNameList}
        tossUpProductNameList={tossUpProductNameList}
        setOnDataAddModalResult={setOnDataAddModalResult}
      />
      <ContractCopyEntryModal
        entryToEntryDataInf={entryToEntryDataInf}
        setEntryToEntryDataInf={setEntryToEntryDataInf}
        closeEntryToEntryModal={closeEntryToEntryModal}
        customerInfo={customerInfo}
        setCustomerInfo={setCustomerInfo}
        addData={entryToEntryAddData}
        setAddData={setEntryToEntryAddData}
        addressOptionName={entryToEntryAddressOptionName}
        setAddressOptionName={setEntryToEntryAddressOptionName}
        selectServisePlanList={entryToEntrySelectServisePlanList}
        setSelectServisePlanList={setEntryToEntrySelectServisePlanList}
        selectServiseContentList={entryToEntrySelectServiseContentList}
        setSelectServiseContentList={setEntryToEntrySelectServiseContentList}
        selectServiseCampaignPulldownList={
          entryToEntrySelectServiseCampaignPulldownList
        }
        setSelectServiseCampaignPulldownList={
          setEntryToEntrySelectServiseCampaignPulldownList
        }
        selectServiseCampaignCheckboxList={
          entryToEntrySelectServiseCampaignCheckboxList
        }
        setSelectServiseCampaignCheckboxList={
          setEntryToEntrySelectServiseCampaignCheckboxList
        }
        selectServisePaymentList={entryToEntrySelectServisePaymentList}
        setSelectServisePaymentList={setEntryToEntrySelectServisePaymentList}
        uniqueOptinList={entryToEntryUniqueOptinList}
        setUniqueOptinList={setEntryToEntryUniqueOptinList}
        postPictures={entryToEntryPostPictures}
        setPostPictures={setEntryToEntryPostPictures}
        onPostButton={onPostButton}
        setOnPostButton={setOnPostButton}
        selectedProductId={selectedProductId}
        setSelectedProductId={setSelectedProductId}
        selectedProductName={selectedProductName}
        setSelectedProductName={setSelectedProductName}
        setOnDataAddModalResult={setOnDataAddModalResult}
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        reloadList={() => getTableData(true)}
      />
      <ChangeAccountCollaborateModal
        onModal={entryToEntryDataInf.addStatus === "change_account"}
        swCloseModal={closeEntryToEntryModal}
        changeAccount={entryToEntryDataInf.changeAccount as 0 | 1}
        changeAccountID={entryToEntryDataInf.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setEntryToEntryDataInf({
            ...entryToEntryDataInf,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setEntryToEntryDataInf({
            ...entryToEntryDataInf,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"エントリー複製"}
        getFormFunction={() => {
          openEntryToEntryData(
            entryToEntryDataInf.contractId,
            entryToEntryDataInf.changeAccount,
            entryToEntryDataInf.changeAccountID,
          );
        }}
        // cmd-po_1212(D2-b): 複製flow担当アカウントstepのステッパー復旧=ContractAd方式(steps prop付与)忠実コピー。写す元=後続ContractCopyEntryModal:1516の実配列。steps以外は不触。
        steps={["担当アカウント", "商材選択", "情報入力"]}
        accountColumn={"営業担当アカウント"}
      />
      <ColumnSettingModal
        onModal={
          columnSetting.status !== "none" && columnSetting.status !== "loading"
        }
        swCloseModal={closeColumnSettingModal}
        columnSetting={columnSetting}
        setColumnSetting={setColumnSetting}
        putClumnSetting={putClumnSetting}
      />
    </Box>
  );
}

export default Contract;
